import React, { Component } from 'react';
import LoginForm from './login-form';
import './login.component.scss';

class LoginModalComponent extends Component {
  render() {
    const { message } = this.props;

    const messageDisplay = !!message ? (
      <div role="alert" aria-live="polite" className="alert alert-success">{message}</div>
    ) : null;

    return (
      <div className="login-modal">
        <div className="login-modal-container">
          {messageDisplay}
          <LoginForm redirect={false} />
        </div>
      </div>
    );
  }
}

export default LoginModalComponent;




// WEBPACK FOOTER //
// src/login/login-modal.component.js